import { FormControl, Typography } from '@material-ui/core';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { FormErrorHelper, IMeta } from './FormErrorHelper';
import { IFormProps } from './IFormProps';

interface IProps<T> extends IFormProps<T> {
    children: any;
    meta: IMeta;
    enter?: () => void;
    leave?: () => void;
}

export const FormControlX = <T extends unknown>({ label, children, meta, enter, leave, helperText, required = false, style, ...rest }: IProps<T>) => {
    const strings = useLocalization();
    return (
        <FormControl
            onMouseEnter={enter}
            onMouseLeave={leave}
            style={{ display: 'flex', marginTop: 8, flexGrow: 1, ...style }}
            {...rest}
            error={meta.error && meta.touched ? true : false}>
            <div className="df-row-ac jc-sb" style={{ marginBottom: 4 }}>
                <Typography variant="body1">{label}</Typography>
                {required === false && <Typography variant="body1" color="textSecondary">{strings.optional}</Typography>}
            </div>
            {children}
            <FormErrorHelper meta={meta} helperText={helperText} />
        </FormControl>
    );
}